import styled from 'styled-components';
import { maxMobile, maxTablet } from 'Utils/utilsStyle';
import PeopleCardListSkeleton from './PeopleCardListSkeleton';

const Wrapper = styled.div`
.peopleListSkeleton {
  padding-top: 20px;
  padding-right: 0px;
  .sub-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .people-list-view-new-class {
      padding-left: 0px;
    }
    .buyer-skeleton-wrapper {
      align-items: center;
      box-shadow: none;
      margin-top: 0px;
      margin-bottom: 0px;
      background-color: transparent;
      padding: 10px 0px;
      .company-logo {
        height: 38px;
        width: 38px;
        @media all and (max-width: ${maxTablet}) {
          width: 40px;
          height: 40px;
        }
        @media all and (max-width: ${maxMobile}) {
          width: 30px;
          height: 30px;
        }
      }
    }
    .details {
      justify-content: center;
      .title-box {
        width: 150px;
        height: 13px;
        border-radius: 10px;
        @media all and (max-width: ${maxMobile}) {
           width: 120px;
           height: 8px;
        }
      }
      .title-box-short{
        border-radius: 10px;
        width: 180px;
        height: 13px;
        @media all and (max-width: ${maxMobile}) {
          width: 150px;
          height: 8px;
        }
      }
      .title-box-short-1 {
        display: none;
      }
    }
    .btn {
      height: 24px;
      border-radius: 20px;
      background-color: rgb(233, 233, 233);
      width: 80px;
      @media all and (max-width: ${maxMobile}) {
        display: none;
        height: 20px;
        width: 50px;
      }
    }
  }
}
`;
const PeopleListViewSkeleton = function PeopleListViewSkeleton() {
  return (
    <Wrapper>
      <div className="peopleListSkeleton">
        {[1, 2, 3, 4, 5].map(() => (
          <div className="sub-container">
            <PeopleCardListSkeleton />
            <span className="btn" />
          </div>
        ))}
      </div>
    </Wrapper>
  );
};
export default PeopleListViewSkeleton;
